import { createSelector } from '@reduxjs/toolkit';

import { authKey, AuthState } from './auth.actions';

export const selectIsLoggedIn = createSelector(
    (state: { [authKey]: AuthState }) => state[authKey],
    (state: AuthState) => state.isLoggedIn,
);

export const selectUserName = createSelector(
    (state: { [authKey]: AuthState }) => state[authKey],
    (state: AuthState) => state.userName,
);
